<template>
  <div class="position-relative">
    <app-loader :is-local="true" v-if="loadMessage"></app-loader>
    <div class="top-panel d-flex align-items-center">
      <p class="fz16 fw500 text-dark text-dots-overflow w-max" :class="{'hideReply': hideReply}">{{selectedEmail.subject}}</p>
      <button class="button-blue-border fz14 fw500 h32 mr8 ml-auto whitespace-nowrap" v-on:click="$emit('createVesselLocation', selectedEmail.id)" v-if="!vesselMode && !hideAddVessel">Add Vessel Location</button>
      <button class="blue-button  w130 h32 cursor-pointer" :class="{'ml-auto': vesselMode}" v-if="!hideReply" v-on:click="$emit('reply')">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2.57197 11.1535C2.47468 11.2319 2.47226 11.3793 2.56693 11.4608L10.7905 18.5422C10.9201 18.6539 11.121 18.5618 11.121 18.3907V14.2028C11.121 14.0923 11.2105 14.0028 11.321 14.0028H11.6973C15.8483 14.0028 17.8807 15.0054 19.7892 17.8495C19.9016 18.017 20.1635 17.9382 20.1532 17.7367C19.8937 12.6727 16.8303 9.18184 11.6973 9.18184H11.321C11.2105 9.18184 11.121 9.09229 11.121 8.98184V4.68475C11.121 4.51674 10.9264 4.4236 10.7955 4.529L2.57197 11.1535Z" stroke="white" stroke-width="1.4"/>
        </svg>
        Reply
      </button>
    </div>
    <template v-if="!vesselMode">
      <div class="msg-info w100Proc box-border mt12 border-radius-8 p12 bgc-gray">

        <div class="d-flex">
          <p class="text-gray w58 fz14 text-align-left">Sender:</p>
          <p class="fz14 text-dark">{{!vesselMode ? selectedEmail.message_from : selectedEmail.email_from}}</p>
        </div>
        <div class="d-flex mt4">
          <p class="text-gray w58 fz14 text-align-left">Sent:</p>
          <p class="fz14 text-dark">{{getFormatTimeMessage(!vesselMode ? selectedEmail.receive_date : selectedEmail.created_at)}}</p>
        </div>
        <div class="d-flex mt4">
          <p class="text-gray w58 fz14 text-align-left">To:</p>
          <p ref="toText" class="fz14 text-dark w-max max-w-591" id="toText" :class="{'text-dots-overflow': !showAll}">{{((!vesselMode ? selectedEmail.message_to : selectedEmail.email_to).toString())}}</p>
        </div>
        <div class="d-flex mt4" v-if="getShow">
          <p class="text-gray w58 fz14 text-align-left opacity-0">To:</p>
          <button class="blue-button-text fz13" v-on:click="showAll = !showAll">
            {{showAll ? 'Hide all' : 'Show all'}}
          </button>
        </div>
        <div class="d-flex mt4" v-if="!vesselMode">
          <p class="text-gray w58 fz14 text-align-left">Parsed:</p>
          <p class="fz14 text-dark">{{getFormatTimeMessage(selectedEmail.created_at)}}</p>
        </div>
        <payment-detail-atachements-file
            v-if="selectedEmail.files.length"
            :file-props="selectedEmail.files"
            class="files mt12"
            :delete-file-permission="false"
            :editPermission="false"
        ></payment-detail-atachements-file>
      </div>
      <p class="mt16 fz14 text-dark" v-html="getMessageHtml()"></p>
    </template>
    <template v-if="vesselMode">
      <div class="mail-detail-wrapper">
        <div class="mail-detail" v-if="selectedEmail">
          <div class="name-row">
<!--            <span class="name-text">{{selectedEmail.subject || '-'}}</span>-->
            <span class="tag" v-for="tag in selectedEmail.tags" :key="tag.id">
                  {{tag.title}}
                  <svg @click="deleteTag(tag.id, selectedEmail.id)" width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.53549 9.09341L6.94283 6.50076L9.53558 3.90801C9.79573 3.64785 9.79573 3.22542 9.53549 2.96518C9.27533 2.70502 8.8529 2.70502 8.59274 2.96518L6 5.55792L3.40726 2.96518C3.1471 2.70502 2.72467 2.70502 2.46451 2.96518C2.20427 3.22542 2.20427 3.64785 2.46442 3.90801L5.05717 6.50076L2.46451 9.09341C2.20427 9.35366 2.20427 9.77609 2.46442 10.0362C2.72467 10.2965 3.1471 10.2965 3.40734 10.0362L6 7.44359L8.59266 10.0362C8.8529 10.2965 9.27533 10.2965 9.53558 10.0362C9.79573 9.77609 9.79573 9.35366 9.53549 9.09341Z" fill="#2C2C2C"/>
                  </svg>
                </span>
          </div>
          <div class="mail-info-block">
            <div class="mail-info-block__row">
              <span class="name">Sender:</span>
              <span class="text">{{selectedEmail.email_from || '-'}}</span>
            </div>

            <div class="mail-info-block__row">
              <span class="name">Sent:</span>
              <span class="text">{{selectedEmail.created_at | formatDateAndTimeSpace2AndSecond}}</span>
            </div>
            <div class="mail-info-block__row">
              <span class="name">To:</span>
              <div class="text-block">
                <span class="text-block__item">{{selectedEmail.email_to.join(', ')}}</span>
              </div>
            </div>
            <div class="mail-info-block__row">
              <span class="name">Parsed:</span>
              <span class="text">{{selectedEmail.parsed_date | formatDateAndTimeSpace2AndSecond}}</span>
            </div>
            <div class="files-block">
              <!-- <a download href="/" class="file" v-for="file in 5" :key="file">
                <div class="file-img"></div>
                <span class="file-name">file-name.pdf</span>
                <span class="file-size">17 KB</span>
              </a> -->
              <a download target="_blank" :href="file.file" class="file" v-for="(file, index) in selectedEmail.files" :key="index">
                <div class="file-img"></div>
                <span class="file-name">{{file.name || '-'}}</span>
                <span class="file-size">{{file.size || 0}}</span>
              </a>
            </div>
          </div>
          <div class="mail-text-block mb40">
            <p class="text" v-html="selectedEmail.text"></p>
            <MessageHistory
                :vesselMode="vesselMode"
                class="mails-history"
                v-if="selectedEmail.reply_history.length != 0"
                :messages="selectedEmail.reply_history"
                :accordeonName="'historyMessage'"
                @deleteHistoryItem="deleteHistoryItem($event)"
            ></MessageHistory>
          </div>
        </div>

      </div>

    </template>

<!--    <div v-if="vesselMode" class="pb40">-->
<!--      <p class="fz14 text-dark mt12" v-html="selectedEmail.text"></p>-->
<!--      <MessageHistory-->
<!--          class="mails-history mt16"-->
<!--          v-if="selectedEmail.reply_history.length != 0"-->
<!--          :messages="selectedEmail.reply_history"-->
<!--          :accordeonName="'historyMessage'"-->
<!--          @deleteHistoryItem="deleteHistoryItem($event)"-->
<!--      ></MessageHistory>-->
<!--    </div>-->
  </div>
</template>

<script>
import moment from 'moment';
import AppLoader from "@/components/loader";
import PaymentDetailAtachementsFile from "@/components/paymentDetail/paymentDetailAtachementsFile";
import MessageHistory from "@/components/mailbox/MessageHistory.vue";
import {mapActions} from "vuex";
export default {
  components: {MessageHistory, PaymentDetailAtachementsFile, AppLoader},
  props: {
    hideAddVessel: Boolean,
    vesselMode: Boolean,
    selectedEmail: null,
    loadMessage: Boolean,
    getShow: Boolean,
    hideReply: Boolean,
  },
  data() {
    return {
      showAll: false,
    }
  },
  name: "location-read-emails-detail",
  methods: {
    ...mapActions(['axiosDeleteMailboxEmailItem']),
    getMessageHtml() {
      return this.selectedEmail.text.replaceAll('\r\n', '<br>')
    },
    getFormatTimeMessage(date) {
      return date ? moment(date).format('DD MMM YY, HH:mm:ss') : ''
    },
    deleteHistoryItem(messageID){
      let data = {
        ids: [messageID]
      }
      this.axiosDeleteMailboxEmailItem(data).then(() => {
        this.selectedEmail.reply_history = this.selectedEmail.reply_history.filter(a=> a.id !== messageID)
      })
    },
  }
}
</script>

<style scoped lang="scss">
.text-dots-overflow.w-max {
  width: calc(100% - 300px);
}

.files {
  /deep/ {
    .navigation-files-block {
      display: none;
    }
  }
}
.max-w-591 {
  max-width: 591px;
}
.hideReply {
  width: 100% !important;
}
.mail-detail-wrapper{
  box-sizing: border-box;
  flex-grow: 1;
  .mail-detail{
    box-sizing: border-box;
    height: 100%;
    //overflow-y: auto;
  }
  .name-row{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    column-gap: 4px;
    row-gap: 4px;
  }
  .name-text{
    padding-right: 4px;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  .tag{
    display: flex;
    align-items: center;
    column-gap: 4px;
    padding: 2px 6px;
    background: var(--color-violet);
    border-radius: 10px;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    min-height: 18px;
    svg{
      &:hover{
        cursor: pointer;
      }
    }
  }
  .mail-info-block{
    margin-top: 16px;
    border-radius: 8px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    background: var(--color-gray-lightest);
    row-gap: 4px;
    .mail-info-block__row{
      display: flex;
      align-items: flex-start;
      column-gap: 15px;
      .name{
        width: 35px;
        min-width: 35px;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        color: var(--color-gray-text);
      }
      .text-block{
        display: flex;
        flex-wrap: wrap;
        column-gap: 4px;
        row-gap: 4px;
      }
      .text, .text-block__item{
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
    }
  }
  .files-block{
    padding-top: 8px;
    display: flex;
    flex-wrap: wrap;
    column-gap: 8px;
    row-gap: 8px;
    .file{
      display: flex;
      flex-direction: column;
      align-items: center;
      row-gap: 2px;
      width: 66px;
      min-width: 66px;
      .file-name{
        padding-top: 2px;
        font-size: 11px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline;
        max-width: 100%;
      }
      .file-size{
        font-size: 10px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        color: var(--color-gray-text);
      }
      .file-img{
        background-image: url("data:image/svg+xml,%3Csvg width='40' height='48' viewBox='0 0 40 48' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3 48H37C38.6569 48 40 46.6569 40 45V13L27 0H3C1.34315 0 0 1.34315 0 3V45C0 46.6569 1.34315 48 3 48Z' fill='%23DEE3EA'/%3E%3Cpath d='M12.9506 31.6148L19.4913 12V28.2712C19.4913 28.5016 19.3571 28.7106 19.1485 28.8052L12.9506 31.6148Z' fill='%239AA3B0'/%3E%3Cpath d='M27.0494 31.6148L20.5087 12V28.2712C20.5087 28.5016 20.6429 28.7106 20.8515 28.8052L27.0494 31.6148Z' fill='%239AA3B0'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M18.6601 17.2724C12.789 17.942 8.22674 22.9613 8.22674 29.0532C8.22674 31.1083 8.74562 33.0403 9.65843 34.7247L19.2353 30.1223V30.9274L9.36213 35.6754L9.19424 35.3854C8.11702 33.525 7.5 31.3611 7.5 29.0532C7.5 22.5847 12.344 17.2562 18.5783 16.5451L18.6601 17.2724ZM31.7733 29.0532C31.7733 22.9613 27.211 17.942 21.3399 17.2724L21.4217 16.5451C27.656 17.2562 32.5 22.5847 32.5 29.0532C32.5 31.3611 31.883 33.525 30.8058 35.3854L30.6359 35.6788L20.7647 30.9412L20.7544 30.1223L30.3435 34.7212C31.2551 33.0376 31.7733 31.1068 31.7733 29.0532Z' fill='%239AA3B0'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M19.2353 33.5294L10.963 37.5732L10.6471 36.9141L19.2353 32.7059V33.5294Z' fill='%239AA3B0'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M19.2353 35.8823L12.6619 39.1399L12.3478 38.4798L19.2353 35.0772V35.8823Z' fill='%239AA3B0'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M19.2353 38.2243L14.2608 40.75L13.9466 40.09L19.2353 37.4192V38.2243Z' fill='%239AA3B0'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M20.7647 33.5294L29.2674 37.5292L29.5833 36.8701L20.7647 32.7059V33.5294Z' fill='%239AA3B0'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M20.7647 35.8823L27.7422 39.1399L28.0562 38.4798L20.7647 35.0772V35.8823Z' fill='%239AA3B0'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M20.7647 38.2243L26.1433 40.75L26.4574 40.09L20.7647 37.4192V38.2243Z' fill='%239AA3B0'/%3E%3Cpath d='M40 13L30 13C28.3431 13 27 11.6569 27 10L27 -1.82822e-07L32.881 5.98L40 13Z' fill='%23BDCBD6'/%3E%3C/svg%3E%0A");
        background-size: cover;
        background-position: center;
        width: 40px;
        height: 48px;
      }
    }
  }
  .mail-text-block{
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    // max-width: 600px;
    /deep/{
      strong{
        font-weight: bold;
      }
      em{
        font-style: italic;
      }
      .ql-align-center{
        text-align: center;
      }
      .ql-align-right{
        text-align: right;
      }
      .ql-align-justify{
        text-align: justify;
      }
      blockquote{
        padding: 10px !important;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        background-color: var(--color-white-dark);
        border-left: 3px solid var(--color-gray);
        margin-bottom: 10px;
        margin-top: 10px;
      }
      .fwd-text_first{
        margin-top: 8px;
      }
      .fwd-text_last{
        margin-bottom: 8px;
      }
      .fwd-text{
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        color: var(--color-dark);
      }
      .ql-syntax, pre{
        background: var(--color-dark);
        color: var(--color-yellow);
        padding: 4px;
        border-radius: 4px;
        width: fit-content;
        margin-bottom: 10px;
        margin-top: 10px;
      }
      ol{
        padding-left: 16px;
        li{
          list-style-type: decimal;
        }
      }
      ul{
        padding-left: 16px;
        li{
          list-style-type: disc;
        }
      }
      p{
        white-space: normal;
      }
      @for $i from 1 to 9{
        $paddingLeft: $i * 10 + '%';
        .ql-indent-#{$i}{
          padding-left: #{$paddingLeft};
        }
      }
      h1{font-size: 2em;}
      h2{font-size: 1.5em;}
      h3{font-size: 1.17em}
      h4{font-size: 1em;}
      h5{font-size: .83em;}
      h6{font-size: .67em;}
      pre{
        max-width: 100%;
        word-wrap: break-word;
        white-space: pre-wrap;
      }
    }
    .text{
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
    .signature{
      margin-top: 30px;
      position: relative;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      &::before{
        content: '--';
        position: absolute;
        top: -16px;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
    }
    .mails-history{
      margin-top: 16px;
    }
  }
  .mail-farme{
    border: 1px solid red;
    display: flex;
    align-self: stretch;
  }
  .mail-placeholder{
    // border: 1px solid red;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background: var(--color-bgc-page);
    .text{
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      padding-top: 16px;
    }
  }
}

</style>